import clsx from 'clsx';

import { ApiKeyType } from '@/types/apiKey';

import styles from './apiKeysPanel.module.scss';


const LABEL: Record<ApiKeyType, string> = {
  personal: 'Personal',
  shared: 'Shared',
  legacy: 'Legacy'
};

export function KeyTypeBadge( { type }: { type: ApiKeyType } ) {
  return (
    <span
      className={ clsx( styles.badge, styles[`badge_${ type }`] ) }
      data-testid={ `api-key-type-badge-${ type }` }
    >
      { LABEL[type] }
    </span>
  );
}
